import _ from 'lodash';
import { ApiRequestHelper } from './lib';
import ApiConfig from './api-config';
import Models from './models';
import Services from './services';
import BaseRepository from './lib/base.repository';
import BaseRepositoryProxyService from './lib/base.repository-proxy.service';


export default class ApiService {

  constructor(opts = null) {
    opts = opts || {};
    this.config = opts.config || new ApiConfig();
    this.request = new ApiRequestHelper(this.config);

    this.models = Models;
    this.serviceNames = [];
    this.services = {};
    this.repos = {};

    let serviceOpts = { request: this.request };
    let repoOpts = _.get(this.config, 'repos', false);

    _.each(Services, ServiceClass => {
      let service = new ServiceClass(serviceOpts);
      let serviceName = service.serviceName || ServiceClass.serviceName || this.formatClassNameToServiceName(ServiceClass.name);
      this.serviceNames.push(serviceName);

      let repo = null;
      let proxy = service;

      let serviceRepoEnabled = _.isBoolean(repoOpts)? !!repoOpts: _.get(repoOpts, serviceName, false);
      // console.log('repo.' + serviceName + ' enabled: ' + serviceRepoEnabled);
      if (false && serviceRepoEnabled) {
        repo = new BaseRepository();
        // repo.name = serviceName;
        // let proxyHandler = {};
        let proxyHandler = new BaseRepositoryProxyService(service, repo);
        proxy = new Proxy(service, proxyHandler);
        // proxy.name = serviceName;
        this.repos[serviceName] = repo;
      }

      this.services[serviceName] = service;
      this[serviceName] = proxy;
    });
  }


  formatClassNameToServiceName(str) {
    str = str || '';
    if (_.endsWith(str, 'Service')) {
      str = str.replace(/Service$/, '');
      str = str.charAt(0).toLowerCase() + str.slice(1);
    }
    return str;
  }
}
